"use client";
import { useRouter } from "next/navigation";
import Image from "next/image";

export default function Home() {
  const router = useRouter();
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 dark:bg-black">
      <div className="flex flex-col gap-8 items-center">
        <div className="flex items-center gap-4 mb-2">
          {/* Room SVG Icon */}
          <span className="inline-flex items-center justify-center rounded-full bg-blue-100 p-3 shadow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-10 h-10 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <rect x="3" y="8" width="18" height="10" rx="2" className="fill-blue-200" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 8V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2" />
              <rect x="9" y="12" width="2" height="4" rx="0.5" className="fill-white" />
            </svg>
          </span>
          <span className="text-4xl font-extrabold tracking-tight text-blue-700 dark:text-blue-200 drop-shadow">
            RoomsApp
          </span>
        </div>
        <div className="text-lg font-medium text-zinc-700 dark:text-zinc-200 mb-4">
          by  NoRiddle <span className="inline-flex items-center justify-center rounded-full bg-blue-100 p-3 shadow">
            <Image
              src="/NoRiddleLogo.png" // or .png if you prefer
              alt="NoRiddle Logo"
              width={48}
              height={48}
              
              priority
            />
          </span> and Stefanos Aslanis
          <br />
         {/*<b>Test Me:<br/>username:test@test.com<br/>password:test</b>*/}
        </div>
        <button
          className="px-8 py-4 rounded bg-blue-600 text-white text-xl font-semibold hover:bg-blue-700 transition"
          onClick={() => router.push("/login")}
        >
          Login
        </button>
        <button
          className="px-8 py-4 rounded bg-green-600 text-white text-xl font-semibold hover:bg-green-700 transition"
          onClick={() => router.push("/client")}
        >
          Device
        </button>
      </div>
    </div>
  );
}